// extracted by mini-css-extract-plugin
export default {"iconOutlinedUser":"IconOutlinedUser_iconOutlinedUser__da-rS","vector":"IconOutlinedUser_vector__iZREM"};